import i18n from '../../plugins/i18n';

function translateBillingModule(billingModule) {
  switch (billingModule) {
    case 'reduced_flat':
      return 'Modul 1 (Pauschale Netzentgeltreduzierung)';
    case 'reduced_separate':
      return 'Modul 2 (Prozentuale Arbeitspreisreduzierung)';
    default:
      return billingModule || '-';
  }
}

function billingModuleObject(rawData) {
  let result = '';

  const devices = rawData.controllable_devices || {};
  const orderedDevices = [
    'wallbox',
    'air_conditioning',
    'heat_pump',
    'battery_storage',
  ];
  orderedDevices.forEach((deviceKey) => {
    const deviceGroup = devices[deviceKey];
    if (!deviceGroup) return;
    const deviceName = i18n.t(`consumption_devices.${deviceKey}`) || deviceKey;

    Object.values(deviceGroup).forEach((device) => {
      result += `<h4>${deviceName}</h4>`;
      result += `${i18n.t(
        'consumption_devices.order_details.billing_module'
      )}: ${translateBillingModule(device.billing_module)}<br><br>`;
    });
  });

  return result || '-';
}

function measureConceptObject(rawData) {
  if (rawData.measure_concept) {
    // Return the German text directly (already stored as German)
    return rawData.measure_concept;
  }
  return '-';
}

export { billingModuleObject, measureConceptObject };
